import { gateway } from "../../../gateway";

export interface ICreateAdminFromInvite {
  inviteToken: string;
  email: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  dialCode: string;
  phone: string;
  password: string;
  confirmPassword: string;
}

export const createAdminFromInvite = async (body: ICreateAdminFromInvite) => {
  try {
    const res = await gateway.post("/users/signup", body);
    return res?.data?.data;
  } catch (error) {
    console.error("Error creating admin from invite", error);
    throw error;
  }
};
